import moment from 'moment';
import { getFixedValue, convert } from '../currencyConvertion';
import messages from '../../locale/messages';
import { getServiceFeeValue } from '../getServiceFeeValue';

export function getCalculationDetails({
	startDate, endDate, serviceFees, specialPricing, currency,
	toCurrency, basePrice, cleaningPrice, monthlyDiscount,
	weeklyDiscount, formatMessage, base, rates, tax, petFee = 0
}) {

	let taxes = 0, totalWithoutTax = 0, bookingSpecialPricing = [], isSpecialPriceAssigned = false;
	let totalWithoutServiceFee = 0, priceForDays = 0, isAverage = 0, isDayTotal = 0, total = 0, discount = 0, totalIncludeTax = 0;
	let momentStartDate, momentEndDate, dayDifference, discountType, oneTotalPrice = 0, petFeeValue = 0;
	let convertPetFee = 0;

	if (startDate && endDate) {
		startDate = moment(startDate).format('YYYY-MM-DD');
		momentStartDate = moment(startDate);
		momentEndDate = moment(endDate);
		dayDifference = momentEndDate.diff(momentStartDate, 'days');
		cleaningPrice = getFixedValue(cleaningPrice);
		basePrice = getFixedValue(basePrice);
		monthlyDiscount = getFixedValue(monthlyDiscount);
		weeklyDiscount = getFixedValue(weeklyDiscount);
		petFeeValue = getFixedValue(petFee);

		if (dayDifference > 0) {
			let stayedNights = [];
			// Find stayed nights
			for (let i = 0; i < dayDifference; i++) {
				let currentDate = moment(startDate).add(i, 'day');
				stayedNights.push(currentDate);
			}

			if (stayedNights?.length > 0) {
				stayedNights.map((item, key) => {
					let isSpecialPricing;
					if (item) {
						let pricingRow, currentPrice;
						isSpecialPricing = specialPricing?.length > 0 && specialPricing?.find(o => moment(item).format('MM/DD/YYYY') == moment(o.blockedDates).format('MM/DD/YYYY'));
						if (isSpecialPricing?.isSpecialPrice && (isSpecialPricing?.dayStatus == 'secondHalf' || isSpecialPricing?.dayStatus == 'full')) {
							isSpecialPriceAssigned = true;
							currentPrice = Number(isSpecialPricing?.isSpecialPrice);
						} else {
							currentPrice = Number(basePrice);
						}
						currentPrice = getFixedValue(currentPrice);
						pricingRow = {
							blockedDates: item,
							isSpecialPrice: currentPrice,
						};
						bookingSpecialPricing.push(pricingRow);
					}
				});
			}
		}

		priceForDays = bookingSpecialPricing.reduce(
			(total, item) => total + Number(item.isSpecialPrice), 0
		);
		priceForDays = getFixedValue(priceForDays);
		discount = 0;
		discountType = null;
		total = 0;
	}

	isAverage = Number(priceForDays) / Number(dayDifference);
	isAverage = getFixedValue(isAverage);
	isDayTotal = isAverage * dayDifference;
	isDayTotal = getFixedValue(isDayTotal);
	priceForDays = isDayTotal;

	if (dayDifference >= 7) {
		if (monthlyDiscount > 0 && dayDifference >= 28) {
			discount = (Number(priceForDays) * Number(monthlyDiscount)) / 100;
			discountType = formatMessage && monthlyDiscount + "% " + formatMessage(messages.monthlyDiscount);
		} else {
			discount = (Number(priceForDays) * Number(weeklyDiscount)) / 100;
			discountType = formatMessage && weeklyDiscount + "% " + formatMessage(messages.weeklyDiscount);
		}
		discount = getFixedValue(discount);
	}
	totalWithoutServiceFee = (priceForDays + cleaningPrice) - discount;
	totalWithoutTax = priceForDays - discount;

	const { guestServiceFee, hostServiceFee, guestServiceFeeType, hostServiceFeeType, guestServiceFeeValue, hostServiceFeeValue } = getServiceFeeValue({ serviceFees, totalWithoutServiceFee, base, rates, currency });

	if (tax) taxes = totalWithoutTax * (Number(getFixedValue(tax)) / 100);
	taxes = getFixedValue(taxes);
	total = (priceForDays + guestServiceFee + cleaningPrice + taxes + petFeeValue) - discount;
	totalIncludeTax = (priceForDays + cleaningPrice + taxes + petFeeValue) - discount;
	oneTotalPrice = (priceForDays + guestServiceFee + cleaningPrice + petFeeValue) - discount;

	if (toCurrency && currency != toCurrency) {
		let priceForDaysConvert, serviceFeeConvert, cleaningPriceConvert, taxesConvert, discountConvert;
		priceForDaysConvert = getFixedValue(convert(base, rates, priceForDays, currency, toCurrency));
		serviceFeeConvert = getFixedValue(convert(base, rates, guestServiceFee, currency, toCurrency));
		cleaningPriceConvert = getFixedValue(convert(base, rates, cleaningPrice, currency, toCurrency));
		taxesConvert = getFixedValue(convert(base, rates, taxes, currency, toCurrency));
		discountConvert = getFixedValue(convert(base, rates, discount, currency, toCurrency));
		convertPetFee = getFixedValue(convert(base, rates, petFeeValue, currency, toCurrency));
		total = (priceForDaysConvert + serviceFeeConvert + cleaningPriceConvert + taxesConvert + convertPetFee) - discountConvert;
		total = convert(base, rates, total, toCurrency, currency);
	}

	return {
		taxes,
		totalWithoutTax,
		bookingSpecialPricing,
		isSpecialPriceAssigned,
		totalWithoutServiceFee,
		priceForDays,
		isAverage,
		total,
		discount,
		dayDifference,
		discountType,
		guestServiceFee,
		hostServiceFee,
		guestServiceFeeType,
		hostServiceFeeType,
		guestServiceFeeValue,
		hostServiceFeeValue,
		totalIncludeTax,
		oneTotalPrice,
		petFeeValue
	};
};
